import { formatDateTimeUnit } from './format-date-time-unit';

export function getDateTimeValueByDate(value = new Date()) {
  // convert to ISO format with current time zone
  const date = `${value.getFullYear()}-${formatDateTimeUnit(
    value.getMonth() + 1
  )}-${formatDateTimeUnit(value.getDate())}`;

  const time = `${formatDateTimeUnit(value.getHours())}:${formatDateTimeUnit(
    value.getMinutes()
  )}`;

  return {
    date,
    time
  };
}
